<template lang="pug">
.social-feed
	transition(name="fadeIn")
		Loader(v-if="loading || error")
		.social-feed__inner(v-else)
			Header
			Cards
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import Loader from "./components/Loader";
import Cards from "./components/Cards";
import Header from "./components/Header";

export default {
	name: "SocialFeed",
  components: {
    Loader,
		Header,
		Cards
  },
	data: function () {
		return {};
	},
	computed: {
		...mapGetters(["socialData", "loading", "error"]),
	},
	methods: {
		...mapActions(["loadSocialData"]),
		getSocialData() {
			this.loadSocialData(this.$root.socialEndpoint);
		}
	},
	created() {
		this.getSocialData();
	}
};
</script>

<style lang="scss">
.fadeIn-enter-active,
.fadeIn-leave-active {
  transition: opacity 0.75s;
}
.fadeIn-enter, .fadeIn-leave-to /* .fadeIn-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fadeIn-leave-to {
  position: absolute;
}
</style>

<style scoped lang="scss">
// .social-feed {
	
// }
</style>